export default __webpack_public_path__ + "static/media/notewrote6.ef8bce45.jpg";